module.exports = __webpack_public_path__ + "vue_assets/media/loading-anim.05c34418.mp4";